/*
 * Viewer 3D – hien thi day dong ho bang Babylon.js.
 * Giu cach phu vat lieu va bat/tat phan model:
 *   - Moi file .glb chua san moi bien the; ten phan co the [..] (vd "[Domed][Oval](Thread) (1)").
 *   - Nhom "Visible": bat phan cua lua chon dang chon, tat phan con lai (co kiem tra the cha/con).
 *   - Nhom "Artwork": phu texture da/lot (artwork = mau, uv_map = van noi).
 *   - Nhom "Color": doi mau chi, mau canh son.
 * Can Babylon.js + babylonjs.loaders duoc nap truoc (window.BABYLON).
 */
(function (global) {
  "use strict";
  var B = global.BABYLON;
  var TAG_RE = /\[.*?\]/g;
  var DEG = Math.PI / 180;

  function tags(name) { return (name || "").match(TAG_RE) || []; }
  function isHex(c) { return /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(c || ""); }

  function StrapViewer(canvas, assets) {
    this.canvas = canvas;
    this.assets = assets || {};
    this.meshes = [];
    this.byId = {};
    this.textureCache = {};
    this.originalRadius = 1;
  }

  StrapViewer.prototype.init = async function () {
    B = global.BABYLON; // thu vien co the duoc tai muon (nguon du phong) -> lay lai luc khoi dong
    // iPhone / iPad: Safari hay loi WebGL2 "Unable to create uniform buffer" -> chay WebGL1 (khong dung uniform buffer).
    // ?s3dgl1=1 de thu che do nay tren may tinh.
    var ua = navigator.userAgent;
    var ios = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
    var gl1 = ios || /[?&]s3dgl1=1/.test(location.search);
    if (!ua.includes("Android") && !gl1) {
      var gl = this.canvas.getContext("webgl2") || this.canvas.getContext("webgl");
      if (gl) gl.disable(gl.DITHER);
    }
    var engineOpts = { preserveDrawingBuffer: true, stencil: true };
    if (gl1) engineOpts.disableWebGL2Support = true;
    var engine = (this.engine = new B.Engine(this.canvas, true, engineOpts));
    if (gl1) engine.disableUniformBuffers = true;
    this.canvas.addEventListener("webglcontextlost", function () { console.warn("[3D] WebGL context lost"); });
    engine.setHardwareScalingLevel(Math.max(0.5, 0.6 / Math.max(1, (global.devicePixelRatio || 1) / 2)));
    var scene = (this.scene = new B.Scene(engine));
    scene.clearColor = B.Color4.FromHexString("#EAEAEAFF");

    [[10, 0, 10], [2, 5, -10], [-2, -5, 10]].forEach(function (p, i) {
      new B.HemisphericLight("light " + i, new B.Vector3(p[0], p[1], p[2]), scene).intensity = 0.9;
    });

    var cam = (this.camera = new B.ArcRotateCamera("cam", 90 * DEG, 90 * DEG, 1, B.Vector3.Zero(), scene));
    cam.attachControl(this.canvas, true);
    cam.minZ = 0.04;
    cam.wheelPrecision = 75;
    cam.fov = Math.PI / 12;
    cam.panningSensibility = 0;
    cam.fovMode = this.canvas.offsetHeight > this.canvas.offsetWidth ? B.Camera.FOVMODE_HORIZONTAL_FIXED : B.Camera.FOVMODE_VERTICAL_FIXED;

    if (this.assets.hdr) {
      scene.environmentTexture = new B.HDRCubeTexture(this.assets.hdr, scene, 128, false, true, false, true);
      scene.environmentIntensity = 1;
    }

    this.ground = B.MeshBuilder.CreateGround("groundPlane", { width: 50, height: 50 }, scene);
    if (this.assets.shadow) {
      try {
        // shadow: link toi file .json, hoac chinh noi dung JSON (nhung trong strap3d-env.js)
        var mat = typeof this.assets.shadow === "string"
          ? await B.NodeMaterial.ParseFromFileAsync("groundNodeMat", this.assets.shadow, scene)
          : B.NodeMaterial.Parse(this.assets.shadow, scene);
        mat.build(false);
        this.ground.material = mat;
      } catch (e) { console.warn("[3D] khong nap duoc vat lieu bong", e); }
    }
    this.ground.receiveShadows = true;

    var light = (this.light = new B.DirectionalLight("lights", new B.Vector3(-0.1, -1, -0.2), scene));
    light.position = new B.Vector3(0, 10, -5);
    light.shadowMinZ = 4;
    light.shadowMaxZ = 10;
    var sg = (this.shadowGenerator = new B.ShadowGenerator(1024, light));
    sg.useBlurExponentialShadowMap = true;
    sg.useKernelBlur = true;
    sg.blurScale = 3;
    sg.blurKernel = 128;
    sg.depthScale = 1;

    engine.runRenderLoop(function () { scene.render(); });
    var self = this;
    this._onResize = function () { engine.resize(); };
    global.addEventListener("resize", this._onResize);
    if (global.ResizeObserver) new ResizeObserver(function () {
      engine.resize();
      cam.fovMode = self.canvas.offsetHeight > self.canvas.offsetWidth ? B.Camera.FOVMODE_HORIZONTAL_FIXED : B.Camera.FOVMODE_VERTICAL_FIXED;
    }).observe(self.canvas);
  };

  StrapViewer.prototype.loadModel = async function (url) {
    // Doi kieu day: bo model cu (ca nut nhom) truoc khi nap model moi
    if (this._loaded) {
      var sg = this.shadowGenerator;
      this._loaded.meshes.forEach(function (m) { if (sg) sg.removeShadowCaster(m); m.dispose(false, false); });
      (this._loaded.transformNodes || []).forEach(function (n) { n.dispose(); });
      this._loaded = null;
    }
    this.meshes = [];
    var res = await B.SceneLoader.ImportMeshAsync("", url, "", this.scene);
    this._loaded = res;
    this.meshes = res.meshes;
    this.nodes = {};
    var self = this;
    this.byId = {};
    this.meshes.forEach(function (m) { self.byId[m.id] = m; });
    // nut cha (TransformNode) cung can de kiem tra quan he [cha][con]
    this.scene.transformNodes.forEach(function (n) { self.nodes[n.id] = n; });
    this.meshes.forEach(function (m) { self.nodes[m.id] = m; });
    this._staticMaterials();
    this._stripOldBrand();
    this._fitCamera();
    this._shadows();
    return res;
  };

  /**
   * Logo thuong hieu tren mat so dong ho: dan nhu decal chieu thang len mat so (khong phu thuoc UV cua model).
   * meshIds: cac mesh mat so (chi mat dang hien), url: anh PNG nen trong suot.
   */
  StrapViewer.prototype.dialLogo = async function (meshIds, url) {
    (this._dialDecals || []).forEach(function (d) { d.dispose(); });
    this._dialDecals = [];
    if (!url) return;
    var scene = this.scene, self = this;
    var tex = await this._texture(url, B.Texture.TRILINEAR_SAMPLINGMODE);
    tex.hasAlpha = true;
    var ratio = tex.getSize().height / Math.max(1, tex.getSize().width) || 0.6;
    if (!this._dialMat) {
      var mat = (this._dialMat = new B.StandardMaterial("dialLogo", scene));
      mat.diffuseTexture = tex; mat.useAlphaFromDiffuseTexture = true;
      // model glTF co truc bi dao (scale am) -> decal bi lat mat va lat chu: tat cull mat sau + lat anh theo chieu doc
      mat.specularColor = B.Color3.Black(); mat.zOffset = -2; mat.backFaceCulling = false;
      tex.vScale = -1;
    }
    // huong "12 gio" = phia co khoa (tren dong ho, day ngan co khoa gan o 12 gio)
    var buckle = this.meshes.find(function (x) { return /Buckle|\(Metallic\)/.test(x.name) && x.isVisible && x.getTotalVertices() > 0; });
    this._find(meshIds).filter(function (m) { return m.isVisible && m.isEnabled() && m.getTotalVertices() > 0; }).forEach(function (m) {
      m.computeWorldMatrix(true);
      var wm = m.getWorldMatrix(), bb = m.getBoundingInfo().boundingBox, c = bb.centerWorld;
      // phap tuyen that cua mat so (trung binh normal dinh, doi sang toa do the gioi) - mat so trong model bi nghieng
      var nr = m.getVerticesData(B.VertexBuffer.NormalKind) || [], ln = new B.Vector3(0, 0, 0);
      for (var i = 0; i < nr.length; i += 3) { ln.x += nr[i]; ln.y += nr[i + 1]; ln.z += nr[i + 2]; }
      var n = B.Vector3.TransformNormal(ln.normalize(), wm).normalize();
      var le = bb.extendSize, r = Math.min(
        B.Vector3.TransformNormal(new B.Vector3(le.x, 0, 0), wm).length(),
        B.Vector3.TransformNormal(new B.Vector3(0, le.y, 0), wm).length());
      // "12 gio" = phia tren man hinh o goc nhin mac dinh (kieu day gap/butterfly co khoa nam duoi -> khong dung khoa duoc)
      var cam = scene.activeCamera;
      if (!self._logoUp && cam) self._logoUp = cam.getDirection(B.Axis.Y).clone();  // giu huong goc nhin dau tien, khong doi khi khach xoay
      var dir = self._logoUp ? self._logoUp.clone() : null;
      if (!dir || B.Vector3.Cross(dir, n).lengthSquared() < 0.05) dir = buckle ? buckle.getBoundingInfo().boundingBox.centerWorld.subtract(c) : new B.Vector3(0, 1, 0);
      var up = dir.subtract(n.scale(B.Vector3.Dot(dir, n)));
      if (up.lengthSquared() < 1e-6) up = new B.Vector3(0, 1, 0);
      up.normalize();
      // xoay decal cho dau logo huong ve 12 gio (cung cong thuc yaw/pitch cua CreateDecal)
      var yaw = -Math.atan2(n.z, n.x) - Math.PI / 2, pitch = Math.atan2(n.y, Math.sqrt(n.x * n.x + n.z * n.z));
      var R0 = B.Matrix.RotationYawPitchRoll(yaw, pitch, 0);
      var u0 = B.Vector3.TransformNormal(new B.Vector3(0, 1, 0), R0), r0 = B.Vector3.TransformNormal(new B.Vector3(1, 0, 0), R0);
      var angle = Math.atan2(-B.Vector3.Dot(up, r0), B.Vector3.Dot(up, u0));
      var w = r * 0.9, h = w * ratio;
      var pos = c.add(up.scale(r * 0.36));
      var d = B.MeshBuilder.CreateDecal("dialLogoDecal", m, { position: pos, normal: n, size: new B.Vector3(w, h, r * 0.6), angle: angle });
      d.material = self._dialMat;
      d.isPickable = false;
      self._dialDecals.push(d);
    });
  };

  /** Model goc co anh in / khac chu thuong hieu cu (HANDDN): bo khoi moi vat lieu con dung. */
  var OLD_BRAND_TEX = /\((Base Color|Normal|Emissive|Metallic Roughness)\)$/;  // ten texture nhung san trong .glb (vd \"DA (Base Color)\")
  StrapViewer.prototype._stripOldBrand = function () {
    var slots = ["albedoTexture", "baseTexture", "diffuseTexture", "bumpTexture", "normalTexture", "emissiveTexture"];
    this.meshes.forEach(function (m) {
      var mat = m.material;
      if (!mat) return;
      slots.forEach(function (k) {
        var t = mat[k];
        if (t && OLD_BRAND_TEX.test(t.name || "")) { mat[k] = null; }
      });
    });
  };

  // ---------- Vat lieu co dinh theo ten phan ----------
  StrapViewer.prototype._staticMaterials = function () {
    var self = this, scene = this.scene;
    this.meshes.forEach(function (m) {
      var n = m.name;
      if (n.includes("(Thread)")) {
        var t = new B.PBRMaterial(n + " Thread", scene);
        t.roughness = 1; t.metallic = 0.3;
        if (self.assets.thread) t.bumpTexture = new B.Texture(self.assets.thread, scene, true, false, B.Texture.LINEAR_LINEAR);
        m.material = t;
      }
      if (n.includes("(Plastic)") && m.material) {
        var p = m.material.clone(n + " Plastic");
        p.metallic = 1; p.roughness = 0.7; m.material = p;
      }
      if (n.includes("(Metallic)")) {
        var mm = new B.PBRMetallicRoughnessMaterial("metallic" + n, scene);
        mm.baseColor = B.Color3.White(); mm.metallic = 0.9; mm.roughness = 0.45;
        if (scene.environmentTexture) mm.environmentTexture = scene.environmentTexture;
        m.material = mm;
      }
      if (n.includes("(Glossy Metallic)")) {
        var g = new B.PBRMetallicRoughnessMaterial("metallic glossy" + n, scene);
        g.baseColor = B.Color3.Gray(); g.metallic = 0.3; g.roughness = 0;
        if (scene.environmentTexture) g.environmentTexture = scene.environmentTexture;
        if (self.assets.metal) self._texture(self.assets.metal, B.Texture.NEAREST_NEAREST).then(function (tx) { g.baseTexture = tx; });
        m.material = g;
      }
    });
  };

  StrapViewer.prototype._fitCamera = function () {
    var ms = this.meshes.filter(function (m) { return m.getTotalVertices && m.getTotalVertices() > 0; });
    if (!ms.length) return;
    var min = ms[0].getBoundingInfo().boundingBox.minimumWorld, max = ms[0].getBoundingInfo().boundingBox.maximumWorld;
    ms.forEach(function (m) {
      var bb = m.getBoundingInfo().boundingBox;
      min = B.Vector3.Minimize(min, bb.minimumWorld); max = B.Vector3.Maximize(max, bb.maximumWorld);
    });
    this.min = min;
    var radius = B.Vector3.Distance(min, max) / 2;
    var c = Math.min(this.canvas.offsetHeight || 600, this.canvas.offsetWidth || 600);
    var d = (180 * (radius / 2645833e-10 / c / (1e3 / c))) / (2 * Math.PI) / 15;
    var start = d / 1.25; // giong app cu tren may tinh
    // Man hinh hep (dien thoai): dam bao thay tron day theo chieu ngang
    var w = this.canvas.offsetWidth || 1, h = this.canvas.offsetHeight || 1, fov = this.camera.fov;
    var fovH = this.camera.fovMode === B.Camera.FOVMODE_HORIZONTAL_FIXED ? fov : 2 * Math.atan(Math.tan(fov / 2) * (w / h));
    var fovV = this.camera.fovMode === B.Camera.FOVMODE_HORIZONTAL_FIXED ? 2 * Math.atan(Math.tan(fov / 2) * (h / w)) : fov;
    var fit = (radius * 0.8) / Math.sin(Math.min(fovH, fovV) / 2);
    if (fit > start) start = fit;
    this.originalRadius = start;
    var cam = this.camera;
    cam.radius = start; cam.lowerRadiusLimit = Math.min(d / 5, start / 4); cam.upperRadiusLimit = Math.max(1.5 * d, start * 1.5);
  };

  StrapViewer.prototype._shadows = function () {
    var sg = this.shadowGenerator;
    if (this.min) this.ground.position.y = this.min.y - 0.3;
    this.meshes.forEach(function (m) { m.receiveShadows = true; sg.addShadowCaster(m); });
  };

  // ---------- Texture ----------
  StrapViewer.prototype._texture = function (url, sampling) {
    var key = url + "|" + sampling, cache = this.textureCache, scene = this.scene;
    if (!cache[key]) {
      cache[key] = new Promise(function (resolve, reject) {
        var tx = new B.Texture(url, scene, true, false, sampling, function () { resolve(tx); }, function (m, e) { reject(e || m); });
      });
    }
    return cache[key];
  };

  /** Phu da/lot: artwork lam mau (albedo), uv lam van noi (bump). */
  StrapViewer.prototype.applyLeather = async function (meshIds, opt) {
    var ms = this._find(meshIds);
    if (!ms.length || !opt || !opt.artwork) return;
    var jobs = [this._texture(opt.artwork, B.Texture.NEAREST_NEAREST)];
    jobs.push(opt.uv ? this._texture(opt.uv, B.Texture.LINEAR_LINEAR) : Promise.resolve(null));
    var res = await Promise.all(jobs), albedo = res[0], bump = res[1], scene = this.scene;
    ms.forEach(function (m) {
      if (!m.material && !opt.newMaterial) return;
      var mat = opt.newMaterial || !m.material ? new B.PBRMaterial(m.id + "leather" + Date.now(), scene) : m.material.clone(m.id + m.name);
      mat.roughness = opt.roughness || 0.7;
      mat.metallic = opt.metallic || 0.6;
      mat.albedoTexture = albedo;
      mat.bumpTexture = bump;
      mat.albedoColor = B.Color3.FromHexString(isHex(opt.tint) ? opt.tint : "#CACACA");
      m.material = mat;
    });
  };

  /** Doi mau (chi, canh son, mat dong ho). keepFinish = giu do nham/kim loai cua vat lieu cu. */
  StrapViewer.prototype.applyColor = function (meshIds, color, newMaterial, keepFinish) {
    if (!color) return;
    var scene = this.scene;
    this._find(meshIds).forEach(function (m) {
      if (!m.material && !newMaterial) return;
      var mat = newMaterial || !m.material ? new B.PBRMaterial(m.id + "color" + Date.now(), scene) : m.material.clone(m.id + color);
      if (!keepFinish) { mat.roughness = 0.8; mat.metallic = 1; }
      mat.albedoColor = isHex(color) ? B.Color3.FromHexString(color).toLinearSpace() : (B.Color3[color] ? B.Color3[color]() : B.Color3.White());
      m.material = mat;
    });
  };

  /** Khoa: texture kim loai (+ normal map khac logo neu co). */
  StrapViewer.prototype.applyMetal = async function (meshIds, opt) {
    if (!opt || !opt.texture) return;
    var ms = this._find(meshIds).filter(function (m) { return !m.name.includes("(NonMetallic)") && m.material; });
    if (!ms.length) return;
    var jobs = [this._texture(opt.texture, B.Texture.NEAREST_NEAREST)];
    jobs.push(opt.normal ? this._texture(opt.normal, B.Texture.LINEAR_LINEAR) : Promise.resolve(null));
    var res = await Promise.all(jobs);
    ms.forEach(function (m) {
      var mat = m.material.clone(m.material.id + " cloned");
      // Model cu: PBRMetallicRoughnessMaterial (baseTexture); model xuat tu Blender: PBRMaterial (albedoTexture)
      if (mat.getClassName() === "PBRMaterial") { mat.albedoTexture = res[0]; mat.albedoColor = B.Color3.White(); }
      else mat.baseTexture = res[0];
      mat.roughness = opt.roughness || 0.45;
      mat.metallic = opt.metalStrength || 0.9;
      mat.normalTexture = res[1] || null;
      m.material = mat;
    });
  };

  StrapViewer.prototype.setVisible = function (meshIds, on) {
    this._find(meshIds).forEach(function (m) { m.visibility = on ? 1 : 0; m.isVisible = !!on; });
  };

  StrapViewer.prototype._find = function (ids) {
    var byId = this.byId;
    return (ids || []).map(function (id) { return byId[id]; }).filter(Boolean);
  };

  /** Duong di tu goc den nut (giong ham N cua app cu). */
  StrapViewer.prototype._path = function (id) {
    var n = this.nodes[id], path = [];
    while (n) { path.unshift(n); n = n.parent; }
    return path;
  };

  /**
   * Bat/tat phan theo cac nhom "Visible" (lam lai ham H cua app cu).
   * groups: [{meshes: [moi phan nhom quan ly], selected: [phan cua lua chon dang chon]}]
   */
  StrapViewer.prototype.applyVisibility = function (groups) {
    var self = this, exists = function (id) { return !!self.byId[id]; };
    // Danh sach chon giu nguyen (gom ca nut nhom cha) de kiem tra quan he cha/con; chi loc khi bat/tat.
    var managed = {}, selectedLists = groups.map(function (g) { return g.selected || []; });
    groups.forEach(function (g) { (g.meshes || []).forEach(function (id) { if (exists(id)) managed[id] = 1; }); });
    var union = [].concat.apply([], selectedLists).filter(exists);

    var parentOk = function (path) {
      var seen = [], ok = true;
      path.forEach(function (node) {
        var second = tags(node.name)[1];
        if (second) {
          var found = selectedLists.some(function (list) {
            return list.some(function (id) { return tags(id)[0] === second && seen.indexOf(id) >= 0; });
          });
          if (!found) ok = false;
        }
        seen.push(node.name);
      });
      return ok;
    };

    var show = union.filter(function (id) {
      if (!tags(id)[1]) return true;
      var path = self._path(id).filter(function (n) { return tags(n.id).length; });
      var parent = path.find(function (n) { return !tags(n.name)[1]; });
      if (!parent) return false;
      var parentSelected = selectedLists.some(function (list) { return list.indexOf(parent.id) >= 0; });
      return parentSelected && parentOk(path);
    });

    this.setVisible(Object.keys(managed), false);
    this.setVisible(show, true);
  };

  /** Xoay camera toi goc cua nhom lua chon (hoat anh 2 giay nhu app cu). */
  StrapViewer.prototype.focus = function (target) {
    var cam = this.camera, scene = this.scene;
    target = target || {};
    var to = { alpha: target.alpha || 90 * DEG, beta: target.beta || 90 * DEG, radius: target.radius || this.originalRadius };
    var ease = new B.CubicEase();
    ease.setEasingMode(B.EasingFunction.EASINGMODE_EASEINOUT);
    var anims = ["alpha", "beta", "radius"].map(function (k) {
      var a = new B.Animation("cam" + k, k, 60, B.Animation.ANIMATIONTYPE_FLOAT, B.Animation.ANIMATIONLOOPMODE_CONSTANT);
      a.setKeys([{ frame: 0, value: cam[k] }, { frame: 120, value: to[k] }]);
      a.setEasingFunction(ease);
      return a;
    });
    scene.beginDirectAnimation(cam, anims, 0, 120, false);
  };

  StrapViewer.prototype.resetView = function () {
    this.camera.target = B.Vector3.Zero();
    this.focus({ alpha: 90 * DEG, beta: 90 * DEG, radius: this.originalRadius });
  };

  /** Chup anh preview (dung cho don hang). */
  StrapViewer.prototype.capture = function (width) {
    width = width || 1000;
    var ratio = this.canvas.width / this.canvas.height;
    return B.Tools.CreateScreenshotAsync(this.engine, this.camera, { width: width, height: Math.round(width / ratio), precision: 2 }, "image/jpeg", 0.9);
  };

  /*
   * Tao "van noi" cho lot co khac logo/chu (lam lai ham S/b/v cua app cu):
   * ve logo/chu len canvas trang -> doi thanh normal map (Sobel) -> lam trong suot phan phang
   * -> chong len uv_map cua lot.
   */
  var SIZES = { Small: [1024, 1024], Square: [1024, 450], "Large Square": [2048, 450], "Nato Large Square": [2048, 450] };
  function sizeOf(size) { return SIZES[size] || [2048, 2048]; }
  function loadImage(src) {
    return new Promise(function (resolve, reject) {
      var im = new Image(); im.crossOrigin = "anonymous";
      im.onload = function () { resolve(im); }; im.onerror = reject; im.src = src;
    });
  }
  function canvasOf(w, h, fontSize) {
    var c = document.createElement("canvas"); c.width = w; c.height = h;
    var x = c.getContext("2d"); x.font = "400 " + (fontSize || 20) + "px Comfortaa, sans-serif";
    x.fillStyle = "white"; x.fillRect(0, 0, w, h);
    return c;
  }
  function toNormalMap(src, bias) {
    var w = src.width, h = src.height, sd = src.getContext("2d").getImageData(0, 0, w, h).data;
    var out = document.createElement("canvas"); out.width = w; out.height = h;
    var octx = out.getContext("2d"), od = octx.createImageData(w, h), d = od.data;
    var z = 1 - ((bias || 70) - 0.1) / 100;
    var R = function (x, y) { x = Math.min(w - 1, Math.max(0, x)); y = Math.min(h - 1, Math.max(0, y)); return sd[(y * w + x) * 4] / 255; };
    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        var d0 = R(x, y), dx = ((R(x - 1, y) - d0) + (d0 - R(x + 1, y))) * 0.7, dy = ((R(x, y - 1) - d0) + (d0 - R(x, y + 1))) * 0.7;
        var len = Math.sqrt(dx * dx + dy * dy + z * z), i = (y * w + x) * 4;
        var nx = Math.round(((dx / len) * 0.4 + 0.5) * 255), ny = Math.round(((dy / len) * 0.4 + 0.5) * 255), nz = Math.round(((z / len) * 0.4 + 0.5) * 255);
        var flat = (nx === 127 || nx === 128) && (ny === 127 || ny === 128);
        d[i] = nx; d[i + 1] = ny; d[i + 2] = nz; d[i + 3] = flat ? 0 : 255;
      }
    }
    octx.putImageData(od, 0, 0);
    return out;
  }

  /**
   * Khac chu/logo len lot: tra ve {uv, artwork}
   *  - uv: ban do van noi co chu (giong app cu)
   *  - artwork: texture mau co chu in chim toi hon (de nhin ro tren man hinh, app cu khong co)
   */
  StrapViewer.prototype.engrave = async function (opt) {
    var text = (opt.text || "").trim();
    if (!text && !opt.logo) return { uv: opt.uv, artwork: opt.artwork };
    var parts = await this._engraveLayer(opt);
    var res = { uv: await this.engravedUv(opt, parts), artwork: opt.artwork };
    if (opt.artwork) {
      var art = await loadImage(opt.artwork), W = art.width, H = art.height;
      var c = document.createElement("canvas"); c.width = W; c.height = H;
      var x = c.getContext("2d");
      x.drawImage(art, 0, 0);
      // chu trong khong gian UV: cung vi tri voi lop van noi (xoay 180 do)
      x.save(); x.translate(W, H); x.rotate(Math.PI);
      x.globalAlpha = 0.55; x.globalCompositeOperation = "multiply";
      x.drawImage(parts.mask, 0, 0, W, H);
      x.restore();
      res.artwork = c.toDataURL("image/jpeg", 0.92);
    }
    return res;
  };

  /** Ve chu/logo len canvas trang (cho van noi) va mot ban mat na trong suot (cho in chim). */
  StrapViewer.prototype._engraveLayer = async function (opt) {
    var text = (opt.text || "").trim();
    var wh = sizeOf(opt.size), w = wh[0], h = wh[1], unit = h / 7;
    var textSize = { Small: 30, Square: 30, "Large Square": 30, "Nato Large Square": 30 }[opt.size] || 20;
    var layer = canvasOf(w, h, textSize), ctx = layer.getContext("2d");
    var mask = document.createElement("canvas"); mask.width = w; mask.height = h;
    var mctx = mask.getContext("2d"); mctx.font = ctx.font;
    var logo = opt.logo ? await loadImage(opt.logo) : null;
    [ctx, mctx].forEach(function (c) {
      if (logo) {
        var lw = 100, lh = lw / (logo.width / logo.height), top, left = 40;
        if (opt.size === "Small") top = 6 * unit;
        else if (opt.size === "Square" || opt.size === "Large Square") top = 5 * unit + unit / 6 - 10;
        else if (opt.size === "Nato Large Square") { top = 5 * unit + unit / 6 - 10; left = 750; }
        else top = 4 * unit + unit / 2;
        c.drawImage(logo, left, top, lw, lh);
      }
      if (text) {
        var ty = { Small: h / 7 - 10, Square: h / 3 - 25, "Large Square": h / 3 - 25, "Nato Large Square": h / 3 - 15 }[opt.size];
        c.fillStyle = "#000";
        c.fillText(text, 25, ty == null ? h / 14 - 10 : ty);
      }
    });
    return { layer: layer, mask: mask, w: w, h: h };
  };

  StrapViewer.prototype.engravedUv = async function (opt, parts) {
    // opt: {size, uv, text, logo}
    var text = (opt.text || "").trim();
    if (!text && !opt.logo) return opt.uv;
    parts = parts || await this._engraveLayer(opt);
    var w = parts.w, h = parts.h;
    var normals = toNormalMap(parts.layer, 70);
    var base = canvasOf(w, h), bctx = base.getContext("2d");
    if (opt.uv) {
      var uv = await loadImage(opt.uv), ratio = uv.width / uv.height, dw = h, dh = w / ratio;
      if (dh > h) { dh = h; dw = w * ratio; }
      bctx.drawImage(uv, (w - dw) / 2, (h - dh) / 2, w, h);
    }
    // App cu xoay lop chu 180 do truoc khi ghep -> chu nam o goc duoi ben phai texture,
    // dung vung lot nhin thay (mat trong nua day dai, gan dong ho)
    bctx.save();
    bctx.translate(w, h);
    bctx.rotate(Math.PI);
    bctx.drawImage(normals, 0, 0);
    bctx.restore();
    return base.toDataURL();
  };

  /**
   * Duc lo "racing" tren mat da (ve bang texture, khong can model rieng).
   * opt: {artwork, uv, color, holes: [[u, v], ...], ru, rv}  (toa do UV 0..1, ban kinh theo chieu u / v)
   * Tra ve {artwork, uv}: lo to mau + vien toi tren artwork, lo lom tren van noi.
   */
  StrapViewer.prototype.perforate = async function (opt) {
    if (!opt.holes || !opt.holes.length || !opt.artwork) return { artwork: opt.artwork, uv: opt.uv };
    var key = [opt.artwork, opt.uv, opt.color, JSON.stringify(opt.holes), opt.ru, opt.rv].join("|");
    this._perf = this._perf || {};
    if (this._perf[key]) return this._perf[key];
    var holes = opt.holes, ru = opt.ru || 0.008, rv = opt.rv || 0.035;
    var draw = function (ctx, W, H, fill) {
      holes.forEach(function (h) {
        ctx.beginPath();
        ctx.ellipse(h[0] * W, h[1] * H, ru * W, rv * H, 0, 0, Math.PI * 2);
        fill(ctx, h[0] * W, h[1] * H, ru * W, rv * H);
      });
    };
    var art = await loadImage(opt.artwork), W = art.width, H = art.height;
    var c = document.createElement("canvas"); c.width = W; c.height = H;
    var x = c.getContext("2d");
    x.drawImage(art, 0, 0);
    draw(x, W, H, function (ctx, cx, cy, rx, ry) {
      ctx.fillStyle = opt.color || "#000000"; ctx.fill();
      // bong do o mot nua lo + vien toi -> nhin ra lo co chieu sau
      var g = ctx.createRadialGradient(cx - rx * 0.35, cy - ry * 0.35, 0, cx, cy, Math.max(rx, ry) * 1.1);
      g.addColorStop(0, "rgba(0,0,0,0.45)"); g.addColorStop(0.6, "rgba(0,0,0,0.1)"); g.addColorStop(1, "rgba(0,0,0,0)");
      ctx.fillStyle = g; ctx.fill();
      ctx.lineWidth = Math.max(1.5, rx * 0.18); ctx.strokeStyle = "rgba(0,0,0,0.55)"; ctx.stroke();
    });
    var res = { artwork: c.toDataURL("image/jpeg", 0.92), uv: opt.uv };
    if (opt.uv) {
      var uv = await loadImage(opt.uv), w = uv.width, h = uv.height;
      var hm = canvasOf(w, h), hx = hm.getContext("2d");
      draw(hx, w, h, function (ctx) { ctx.fillStyle = "#000"; ctx.fill(); });
      var normals = toNormalMap(hm, 60);
      var base = document.createElement("canvas"); base.width = w; base.height = h;
      var bx = base.getContext("2d");
      bx.drawImage(uv, 0, 0);
      bx.drawImage(normals, 0, 0);
      res.uv = base.toDataURL();
    }
    this._perf[key] = res;
    return res;
  };

  global.StrapViewer = StrapViewer;
})(window);
